import { NumberOutlined, SaveFilled } from "@ant-design/icons"
import { useMemo, useState } from "react"
import { Input, Button, Modal, Form, Select, Spin, Alert, Space, Tag, Typography } from "antd"

const { Title, Text, Paragraph } = Typography

// Normalize serial to what backend accepts (remove Persian/Arabic chars, non-ASCII, and map Persian digits)
const normalizeSerialInput = value => {
  if (!value) return ""

  const persianDigitMap = {
    "۰": "0",
    "۱": "1",
    "۲": "2",
    "۳": "3",
    "۴": "4",
    "۵": "5",
    "۶": "6",
    "۷": "7",
    "۸": "8",
    "۹": "9",
  }

  const withEnglishDigits = value.replace(
    /[۰-۹]/g,
    d => persianDigitMap[d] || ""
  )
  const withoutPersianArabic = withEnglishDigits.replace(
    /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/g,
    ""
  )
  const onlyAllowed = withoutPersianArabic.replace(/[^a-zA-Z0-9]/g, "")

  return onlyAllowed
}

const SubmitPackageSerialNumber = ({ rowData, mainProps }) => {
  const unitCount = rowData.unitNumber || 1
  const { lstPackageInstaller, onGetListPackageInstaller, installerLoading } =
    mainProps


  const packageCompanyName = rowData.packageCompanyName
  console.log('packageCompanyName', packageCompanyName);
  

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [form] = Form.useForm()
  const rawSerial = Form.useWatch("serialNumber", form)
  const normalizedSerialPreview = useMemo(
    () => normalizeSerialInput(rawSerial || ""),
    [rawSerial]
  )

  const serialDiffersFromInput = useMemo(
    () => !!rawSerial && rawSerial !== normalizedSerialPreview,
    [rawSerial, normalizedSerialPreview]
  )

  const showModal = () => {
    onGetListPackageInstaller()
    setIsModalVisible(true)
  }
  const handleCancel = () => setIsModalVisible(false)




  const handleSubmit = async () => {
 

    const values = await form.validateFields()
    const normalizedSerial = normalizeSerialInput(values.serialNumber)

    mainProps.onSubmitPackage({
      fileNumber: rowData.fileNumber,
      smsCode: rowData.packageInstallerCode,
      serialNumber: normalizedSerial,
    })

    setIsModalVisible(false)
  }

  return (
    <div>
      {!rowData.packageInstallerSubmit ? (
        <>
          <Button
            icon={<SaveFilled />}
            type="primary"
            onClick={showModal}
            size="small"
          >
            ثبت
          </Button>

          <Modal
            title="ثبت شماره سریال"
            open={isModalVisible}
            onOk={handleSubmit}
            onCancel={handleCancel}
            okText="ثبت"
            cancelText="لغو"
          >
            <Alert
              type="info"
              showIcon
              message={packageCompanyName}
              style={{ marginTop: 4 }}
            />
            <Form form={form} layout="vertical">
              <Form.Item
                name="serialNumber"
                label={
                  <Space>
                    <NumberOutlined />
                    <span>شماره سریال </span>
                  </Space>
                }
                rules={[
                  { required: true, message: "لطفاً شماره سریال را وارد کنید" },
                  { min: 3, message: "شماره سریال باید حداقل 3 کاراکتر باشد" },
                ]}
              >
                <Input
                  placeholder="شماره سریال  را وارد کنید"
                  size="large"
                  style={{ borderRadius: 8, fontFamily: "tahoma" }}
                  prefix={<NumberOutlined style={{ color: "#bfbfbf" }} />}
                />
              </Form.Item>

              <div style={{ marginTop: -8, marginBottom: 16 }}>
                <Space direction="vertical" size={4} style={{ width: "100%" }}>
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    سریال مجاز پس از تبدیل:
                  </Text>
                  <Tag
                    color="blue"
                    style={{ fontFamily: "tahoma", marginRight: 0 }}
                  >
                    {normalizedSerialPreview || "—"}
                  </Tag>
                  {serialDiffersFromInput && (
                    <Alert
                      type="warning"
                      showIcon
                      message="کاراکترهای غیرمجاز حذف یا تبدیل می‌شوند. فقط حروف انگلیسی و اعداد مجازند."
                      style={{ marginTop: 4 }}
                    />
                  )}
                </Space>
              </div>
            </Form>
          </Modal>
        </>
      ) : (
        <span>
          شماره سریال ثبت شده:
          <div>{rowData.packageSerialNumber}</div>
        </span>
      )}
    </div>
  )
}

export default SubmitPackageSerialNumber
